import {ILiveEventAnalyticsRepository} from "./live-event-analytics.repository";
import {LiveEventAnalyticsRepositoryV2} from "./live-event-analytics.repository.v2";

export type {
  ILiveEventAnalyticsRepository,
  GetAttendeesResult,
  GetAttendeeDetailsParams,
  ExportAttendeesCSVParams,
} from "./live-event-analytics.repository";
export {LiveEventAnalyticsRepositoryV2} from "./live-event-analytics.repository.v2";

/**
 * Creates the LiveEventAnalyticsRepository.
 * Always returns the v2 implementation (v1 has been removed).
 *
 * @example
 * const repository = createLiveEventAnalyticsRepository();
 * const insights = await repository.getSalesInsights(eventId);
 */
export const createLiveEventAnalyticsRepository = (): ILiveEventAnalyticsRepository => {
  return new LiveEventAnalyticsRepositoryV2();
};
